<template>
  <div class="app-main">
    <section>
      <!-- <img src="../../assets/img/pdfimg/drug.png" alt=""> -->
      <div class="drugtitle">国内药品清单</div>
         <table class="production-table">
                  <tr>
                    <th>序号</th>
                    <th>商品名</th>
                    <th>通用名</th>
                    <th>适应疾病</th>
                    <th>药企</th>
                    <th>指定适应症</th>
                  </tr>
                  <tr > <td>1</td>
                  <td>达希纳</td>
                  <td>尼洛替尼胶囊</td>
                  <td>白血病</td>
                  <td >诺华</td>
                  <td >本产品用于治疗2岁以上儿童慢性髓性白血病</td>
                  </tr>

                  <tr > <td  >2</td>
                  <td>拓舒沃</td>
                  <td>艾伏尼布</td>
                  <td>白血病</td>
                  <td >基石制药</td>
                  <td >本产品用于治疗携带IDH1突变的急性骨髓性白血病患者</td>
                  </tr>

                  <tr > <td >3</td>
                  <td>唯可来</td>
                  <td>维奈克拉片</td>
                  <td>白血病</td>
                  <td >艾伯维</td>
                  <td >本品与阿扎胞苷联合用于治疗因合并症不适合接受强诱导化疗，或者年龄75岁及以上的新诊断的成人急性髓系白血病患者</td>
                  </tr>

                  <tr > <td  >4</td>
                  <td>艾瑞卡</td>
                  <td>卡瑞利珠单抗</td>
                  <td>鼻咽癌</td>
                  <td >江苏恒瑞</td>
                  <td >本产品用于治疗既往接受过二线及以上化疗后疾病进展或不可耐受的晚期鼻咽癌患者的治疗。</td>
                  </tr>

                  <tr > <td  >5</td>
                  <td>拓益</td>
                  <td>特瑞普利单抗</td>
                  <td>鼻咽癌、尿路上皮癌</td>
                  <td>君实</td>
                  <td >本产品用于治疗：
                  1.用于含铂化疗失败包括新辅助或辅助化疗12个月内进展的局部晚期或转移性尿路上皮癌的治疗。
                  2.用于既往接受过二线及以上系统治疗失败的复发/转移性鼻咽癌患者的治疗</td>
                  </tr>

                  <tr > <td >6</td>
                  <td>兆珂</td>
                  <td>达雷妥尤单抗</td>
                  <td>多发性骨髓瘤</td>
                  <td >西安杨森</td>
                  <td >本产品单药治疗复发和难治性多发性骨髓瘤成年患者，患者既往接受过包括蛋白酶体抑制剂和免疫调节剂的治疗且最后一次治疗时出现疾病进展。</td>
                  </tr>

                  <tr > <td  >7</td>
                  <td >阿美乐</td>
                  <td >甲磺酸阿美替尼片</td>
                  <td >肺癌</td>
                  <td >江苏豪森药业</td>
                  <td >本品适用于既往经表皮生长因子受体（EGFR）酪氨酸激酶抑制剂（TKI）治疗时或治疗后出现疾病进展，并且经检测确认存在 EGFR T790M 突变阳性的局部晚期或转移性非小细胞肺癌（NSCLC）成人患者的治疗。</td>
                  </tr>

                  <tr > <td >8</td>
                  <td>泰瑞沙</td>
                  <td>甲磺酸奥希替尼片</td>
                  <td>肺癌</td>
                  <td >阿斯利康</td>
                  <td >本品适用于既往经表皮生长因子受体(EGFR)酪氨酸激酶抑制剂(TKI)治疗时或治疗后出现疾病进展，并且经检测确认存在EGFR T790M突变阳性的局部晚期或转移性非小细胞性肺癌(NSCLC)成人患者的治疗。</td>
                  </tr>

                  <tr > <td >9</td>
                  <td>欧狄沃</td>
                  <td >纳武利尤单抗注射液</td>
                  <td >肺癌、头颈部鳞状细胞癌、胃或胃食管连接部腺癌</td>
                  <td >百时美施贵宝</td>
                  <td >1.非小细胞肺癌（NSCLC）
                  本品单药适用于治疗表皮生长因子受体（EGFR）基因突变阴性和间变性淋巴瘤激酶（ALK）阴性、既往接受过含铂方案化疗后疾病进展或不可耐受的局部晚期或转移性非小细胞肺癌（NSCLC）成人患者。
                  2.胃或胃食管连接部腺癌
                  本品可用于治疗既往接受过两种或两种以上全身性治疗方案的晚期或复发性胃或胃食管连接部腺癌患者。
                  3.头颈部鳞状细胞癌 ( SCCHN )
                  本品单药适用于治疗接受含铂类方案治疗期间或之后出现疾病进展且肿瘤 PD-Ll 表达阳性(定义为表达PD-Ll 的肿瘤细胞≥1%)的复发性或转移性头颈部鳞状细胞癌( SCCHN ) 患者。 
                  </td>
                  </tr>

                  <tr > <td  >10</td>
                  <td>艾弗沙</td>
                  <td>伏美替尼</td>
                  <td>肺癌</td>
                  <td>艾力斯</td>
                  <td >本产品用于既往经表皮生长因子受体（EGFR）酪氨酸激酶抑制剂（TKI）治疗时或治疗后出现疾病进展，并且经检测确认存在EGFR T790M突变阳性的局部晚期或转移性非小细胞性肺癌（NSCLC）成人患者的治疗</td>
                  </tr>

                  <tr > <td>11</td>
                  <td>可瑞达</td>
                  <td>帕博利珠单抗注射液</td>
                  <td>肺癌</td>
                  <td >默沙东</td>
                  <td >帕博利珠单抗适用于由国家药品监督管理局批准的检测评估为 PD-L1 肿瘤比例分数（TPS） ≥ 1% 的表皮生长因子受体（EGFR）基因突变阴性和间变性淋巴瘤激酶（ALK）阴性的局部晚期或转移性非小细胞肺癌一线单药治疗。
                  帕博利珠单抗联合培美曲塞和铂类化疗适用于表皮生长因子受体（EGFR）基因突变阴性和间变性淋巴瘤激酶（ALK）阴性的转移性非鳞状非小细胞肺癌（NSCLC）的一线治疗。
                  帕博利珠单抗联合卡铂和紫杉醇适用于转移性鳞状非小细胞肺癌（NSCLC）患者的一线治疗。</td>
                  </tr>

                  <tr > <td >12</td>
                  <td>普吉华</td>
                  <td>普拉替尼</td>
                  <td>肺癌</td>
                  <td >基石制药</td>
                  <td >本产品用于治疗既往接受过含铂化疗的转染重排（RET）基因融合阳性的局部晚期或转移性非小细胞肺癌（NSCLC）成人患者的治疗。</td>
                  </tr>

                  <tr > <td  >13</td>
                  <td>英飞凡</td>
                  <td>度伐利尤单抗</td>
                  <td>肺癌</td>
                  <td>阿斯利康</td>
                  <td >本产品用于治疗在接受铂类药物为基础的化疗同步放疗后未出现疾病进展的不可切除、III 期非小细胞肺癌(NSCLC)患者的治疗。</td>
                  </tr>

                  <tr > <td  >14</td>
                  <td>泽普生</td>
                  <td>甲苯磺酸多纳非尼片</td>
                  <td>肝癌</td>
                  <td>泽璟制药</td>
                  <td >用于治疗晚期（无法手术或转移性）肝细胞癌。</td>
                  </tr>

                  <tr > <td  >15</td>
                  <td>多泽润</td>
                  <td >达可替尼片</td>
                  <td>肺癌</td>
                  <td >辉瑞</td>
                  <td >单药用于表皮生长因子受体（EGFR）19 号外显子缺失突变或 21 号外显子 L858R 置换突变的局部晚期或转移性非小细胞肺癌（NSCLC）患者的一线治疗。</td>
                  </tr>

                  <tr > <td >16</td>
                  <td>宜诺凯</td>
                  <td>奥布替尼</td>
                  <td>淋巴瘤</td>
                  <td >诺诚健华</td>
                  <td >1.既往至少接受过一种治疗的成人套细胞淋巴瘤（MCL）患者。
                  2.既往至少接受过一种治疗的成人慢性淋巴细胞白血病（CLL）/小淋巴细胞淋巴瘤（SLL）患者。</td>
                  </tr>

                  <tr > <td  >17</td>
                  <td>艾瑞颐</td>
                  <td>氟唑帕利胶囊</td>
                  <td>卵巢癌</td>
                  <td >江苏恒瑞</td>
                  <td >本产品用于既往经过二线及以上化疗的伴有胚系BRCA突变(gBRCAm)的铂敏感复发性卵巢癌、输卵管癌或原发性腹膜癌患者的治疗。</td>
                  </tr>

                  <tr > <td >18</td>
                  <td>安可坦</td>
                  <td >恩扎卢胺软胶囊</td>
                  <td>前列腺癌</td>
                  <td >安斯泰来</td>
                  <td >本产品用于雄激素剥夺治疗（ADT）失败后无症状或有轻微症状且未接受化疗的转移性去势抵抗性前列腺癌（CRPC）成年患者的治疗</td>
                  </tr>

                  <tr > <td>19</td>
                  <td>安森珂</td>
                  <td>阿帕他胺</td>
                  <td>前列腺癌</td>
                  <td >西安杨森</td>
                  <td >本产品用于治疗有高危转移风险的非转移性去势抵抗性前列腺癌（NM-CRPC）成年患者。</td>
                  </tr>

                  <tr > <td>20</td>
                  <td>爱博新</td>
                  <td>哌柏西利胶囊</td>
                  <td>乳腺癌</td>
                  <td>辉瑞</td>
                  <td >本品适用于激素受体(HR)阳性、人表皮生长因子受体 2 (HER2)阴性的局部晚期或转移性乳腺癌，应与芳香化酶抑制剂联合使用作为绝经后女性患者的初始内分泌治疗。</td>
                  </tr>

                  <tr > <td>21</td>
                  <td>海乐卫</td>
                  <td>艾立布林</td>
                  <td>乳腺癌</td>
                  <td>卫材</td>
                  <td >本品适用于既往接受过至少两种化疗方案的局部晚期或转移性乳腺癌患者。既往的化疗方案应包含一种蒽环类和一种紫杉烷类药物。</td>
                  </tr>

                  <tr > <td >22</td>
                  <td>唯择</td>
                  <td>阿贝西利</td>
                  <td>乳腺癌</td>
                  <td >礼来</td>
                  <td >本产品用于治疗激素受体（HR）阳性、人表皮生长因子受体 2（HER2）阴性的局部
                  晚期或转移性乳腺癌：
                  1、与芳香化酶抑制剂联合使用作为绝经后女性患者的初始内分泌治疗；
                  2、与氟维司群联合用于既往曾接受内分泌治疗后出现疾病进展的患者。</td>
                  </tr>

                  <tr > <td>23</td>
                  <td>爱必妥</td>
                  <td >西妥昔单抗注射液</td>
                  <td>头颈部鳞状细胞癌</td>
                  <td >默克</td>
                  <td >本产品与化疗药铂类以及氟尿嘧啶联合，用于一线治疗复发/转移性头颈部鳞状细胞癌（R/M SCCHN）</td>
                  </tr>

                  <tr > <td>24</td>
                  <td>泰吉华</td>
                  <td>阿伐替尼</td>
                  <td >胃肠道间质瘤</td>
                  <td >基石制药</td>
                  <td >本产品用于治疗患有血小板源性生长因子受体α（PDGFRA）D842V突变的不可切除或转移性胃肠道间质瘤（GIST）的成人患者。</td>
                  </tr>

                  <tr > <td >25</td>
                  <td>擎乐</td>
                  <td>瑞派替尼</td>
                  <td >胃肠道间质瘤</td>
                  <td >再鼎医药</td>
                  <td >用于已治疗接受过包括伊马替尼在内的3种及以上激酶抑制剂治疗的晚期胃肠道间质瘤（GIST）成人患者。</td>
                  </tr>
        </table> 
        <div class="drugtitle">海外药品清单</div>
          <table class="production-table">
              <tr>
                <th>序号</th>
                <th>商品名</th>
                <th>通用名</th>
                <th>适应疾病</th>
                <th>药企</th>
                <th>指定适应症</th>
              </tr>
              <tr > <td >1</td>
              <td>Besponsa</td>
              <td>Inotuzumab Ozogamicin</td>
              <td>白血病</td>
              <td>辉瑞</td>
              <td >本产品用于治疗复发性或难治性成人前体B细胞急性淋巴细胞白血病</td>
              </tr>

              <tr > <td  >2</td>
              <td >Daurismo </td>
              <td >Glasdegib</td>
              <td >白血病</td>
              <td >辉瑞</td>
              <td >本产品用于治疗75岁以上新诊断或不能耐受高强度化疗的急性髓细胞白血病</td>
              </tr>

              <tr > <td >3</td>
              <td >Idhifa</td>
              <td >enasidenib</td>
              <td >白血病</td>
              <td>Celgene Corporation</td>
              <td >本产品用于治疗携带异柠檬酸脱氢酶2（IDH2）基因突变的成人复发或难治性急性髓系白血病</td>
              </tr>

              <tr > <td >4</td>
              <td>Mylotarg</td>
              <td>Gemtuzumab Ozogamicin</td>
              <td>白血病</td>
              <td>辉瑞</td>
              <td >本产品用于治疗：
              1、用于未经治疗的CD33阳性的急性髓细胞成人白血病
              2、用于治疗复发或治疗无效的CD33阳性的成人或两岁以上的小儿急性髓细胞白血病。</td>
              </tr>

              <tr > <td  >5</td>
              <td >Onureg</td>
              <td >阿扎胞苷片</td>
              <td >白血病</td>
              <td >百时美施贵宝</td>
              <td >阿扎胞苷片于2020年9月1日在美国获得批准，用于无适用于在接受诱导治疗联合或不联合巩固治疗后达到完全缓解（CR）或血细胞计数未完全恢复的完全缓解（CRi）且不适合进行造血干细胞移植（HSCT）的成人急性髓系白血病（AML）患者的维持治疗。</td>
              </tr>

              <tr > <td  >6</td>
              <td >Rydapt</td>
              <td >Midostaurin</td>
              <td >白血病</td>
              <td >诺华肿瘤</td>
              <td >本产品用于治疗：
              FLT3突变阳性的急性髓性白血病（AML）成人患者</td>
              </tr>

              <tr > <td  >7</td>
              <td >Tibsovo</td>
              <td >ivosidenib</td>
              <td >白血病</td>
              <td>Agios Pharmaceuticals, Inc.</td>
              <td >Tibsovo是一种针对IDH1酶的口服靶向抑制剂，用于经一款检测方法（雅培RealTime IDH1伴随诊断试剂盒）证实存在易感异柠檬酸脱氢酶-1（IDH1）突变的复发性或难治性急性髓系白血病（R/R AML）成人患者</td>
              </tr>

              <tr > <td >8</td>
              <td >施达赛</td>
              <td >达沙替尼片</td>
              <td >白血病</td>
              <td >施贵宝</td>
              <td >1、治疗耐药或不耐受先前治疗的成人费城染色体阳性(Ph+)急性淋巴细胞白血病(ALL)。
              2、联合化疗用于≥1岁的新诊断的费城染色体阳性（Ph+）的急性淋巴细胞白血病（ALL）儿童的治疗。
              3、治疗新诊断的Ph+慢性粒细胞白血病(CML)慢性期；
              4、≥1岁儿童慢性期Ph+CML的治疗。</td>
              </tr>

              <tr > <td x:num="9" >9</td>
              <td >拓舒沃</td>
              <td >艾伏尼布</td>
              <td >白血病</td>
              <td >基石药业</td>
              <td >本产品用于治疗年龄&gt;=75岁或因合并症无法使用强化诱导化疗的IDH1突变新诊断急性髓系白血病</td>
              </tr>

              <tr > <td x:num="10" >10</td>
              <td>Calquence</td>
              <td>Acalabrutinib</td>
              <td>白血病、淋巴瘤</td>
              <td>阿斯利康</td>
              <td >本产品用于治疗：<br />
              1、慢性淋巴细胞白血病/小淋巴细胞淋巴瘤（CLL/SLL）<br />
              2、至少接收过一次其他药物治疗的套细胞淋巴瘤 (R/R MCL)</td>
              </tr>

              <tr > <td x:num="11" >11</td>
              <td>Kymriah</td>
              <td >tisagenlecleucel</td>
              <td >白血病、淋巴瘤</td>
              <td >诺华肿瘤</td>
              <td >本产品用于治疗：<br />
              1、复发或难治性大B细胞淋巴瘤（DLBCL）的成人患者<br />
              2、复发或难治性25岁以下B细胞前体急性淋巴性白血病（ALL）</td>
              </tr>

              <tr > <td x:num="12" >12</td>
              <td >RITUXAN HYCELA</td>
              <td >Rituximab/hyaluronidase human</td>
              <td >白血病、淋巴瘤</td>
              <td >罗氏制药</td>
              <td >本产品使用：<br />
              1、用于治疗复发性或难治性、低度或滤泡性、CD20阳性、B细胞、非霍奇金淋巴瘤。<br />
              2、适用于弥漫性大B细胞、CD20阳性、非霍奇金淋巴瘤的一线治疗，并与CHOP或其他蒽环类化疗方案联合应用。<br />
              3、慢性淋巴细胞白血病</td>
              </tr>

              <tr > <td x:num="13" >13</td>
              <td>Venclexta</td>
              <td>Venetoclax</td>
              <td>白血病、淋巴瘤</td>
              <td>艾伯维/Genentech</td>
              <td >本产品用于治疗：<br />
              成人慢性淋巴细胞白血病（CLL）或小淋巴细胞淋巴瘤（SLL）</td>
              </tr>

              <tr > <td x:num="14" >14</td>
              <td >Pemazyre</td>
              <td >pemigatinib</td>
              <td >胆管癌</td>
              <td >信达生物</td>
              <td >本产品用于治疗复发的FGFR2基因融合或重排的局部晚期或转移性胆管癌</td>
              </tr>

              <tr > <td x:num="15" >15</td>
              <td >Abecma</td>
              <td >idecabtagene vicleucel</td>
              <td >多发性骨髓瘤</td>
              <td>Celgene Corporation</td>
              <td >本产品用于治疗复发或难治性多发性骨髓瘤成人患者</td>
              </tr>

              <tr > <td x:num="16" >16</td>
              <td >BLENREP</td>
              <td >Belantamab Mafodotin-blmf</td>
              <td >多发性骨髓瘤</td>
              <td >葛兰素史克</td>
              <td >本产品用于成人复发性或难治性多发性骨髓瘤的治疗</td>
              </tr>

              <tr > <td x:num="17" >17</td>
              <td >Elotuzumab</td>
              <td >EMPLICITI</td>
              <td >多发性骨髓瘤</td>
              <td >施贵宝</td>
              <td >Elotuzumab是一种靶向淋巴细胞活化分子F7(SLAMF7)的单克隆抗体，可通过直接激活自然杀伤（NK）细胞和抗体依赖的细胞毒性反应来引发其抗肿瘤作用。已证实在复发和难治性患者中，Elotuzumab与免疫调节剂和其他药物合用具有显著疗效。FDA已批准其与来那度胺和地塞米松(E-Rd)联合治疗既往接受过一到三种方案的复发难治多发性骨髓瘤成人患者；或与泊马度胺和地塞米松（E-Pd）联合治疗至少接受过含来那度胺和PI两种治疗的多发性骨髓瘤成人患者。</td>
              </tr>

              <tr > <td x:num="18" >18</td>
              <td>Pepaxto</td>
              <td>melphalan flufenamide 美法仑氟苯甲酰胺</td>
              <td>多发性骨髓瘤</td>
              <td>维健医药</td>
              <td >PEPAXTO®(美法仑氟苯甲酰胺)与地塞米松联用,用于治疗复发或难治性多发性骨髓瘤成人患者。</td>
              </tr>

              <tr > <td x:num="19" >19</td>
              <td>Pomalyst</td>
              <td>泊马度胺</td>
              <td>多发性骨髓瘤</td>
              <td>施贵宝</td>
              <td >本产品用于治疗：<br />
              1、用于≥2次既往治疗失败（包括来那度胺和蛋白酶抑制剂），并且在完成末次治疗的≤ 60天内出现疾病进展的多发性骨髓瘤患者。<br />
              2、用于治疗卡波西肉瘤（Kaposi Sarcoma）药物</td>
              </tr>

              <tr > <td x:num="20" >20</td>
              <td>Sarclisa</td>
              <td>Isatuximab</td>
              <td>多发性骨髓瘤</td>
              <td>赛诺菲</td>
              <td >本产品适用：<br />
              1、联合卡非佐米和地塞米松治疗接受过至少一种既往治疗的多发性骨髓瘤成年患者<br />
              2、联合泊马度胺和地塞米松治疗至少接受过两种既往治疗（包括来那度胺和一种蛋白酶抑制剂）的多发性骨髓瘤成年患者</td>
              </tr>

              <tr > <td x:num="21" >21</td>
              <td>兆珂</td>
              <td>达雷妥尤单抗注射液</td>
              <td >多发性骨髓瘤</td>
              <td>西安杨森制药有限公司</td>
              <td >本产品适用：<br />
              1. 与泊马利度胺和地塞米松联合治疗至少接受过两种治疗的多发性骨髓瘤患者，包括来那度胺和蛋白酶体抑制剂<br />
              2.联合硼替佐米、美法仑和泼尼松治疗不符合自体干细胞移植条件的多发性骨髓瘤新诊断患者</td>
              </tr>

              <tr > <td x:num="22" >22</td>
              <td >XPOVIO</td>
              <td >selinexor</td>
              <td >多发性骨髓瘤、淋巴瘤</td>
              <td >Karyopharm Therapeutics Inc（国内：德琪制药）</td>
              <td >1、与地塞米松联合治疗复发或难治性多发性骨髓瘤的成人患者。这些患者至少接受过包括蛋白酶体抑制剂，免疫调节剂和CD38单克隆抗体在内的多线治疗<br />
              2、硼替佐米联合地塞米松治疗至少接受过一次治疗的成人多发性骨髓瘤<br />
              3、用于治疗成人复发性或难治性弥漫性大B细胞淋巴瘤（DLBCL</td>
              </tr>

              <tr > <td x:num="23" >23</td>
              <td>Alunbrig</td>
              <td>Brigatinib</td>
              <td>肺癌</td>
              <td>武田</td>
              <td >本产品用于间变性淋巴瘤激酶（ALK）阳性的局部晚期或转移性非小细胞肺癌(NSCLC)成人患者的治疗。</td>
              </tr>

              <tr > <td x:num="24" >24</td>
              <td >Cometriq</td>
              <td >Cabozantinib</td>
              <td >甲状腺髓样癌</td>
              <td >Exelixis</td>
              <td >COMETRIQ是激酶抑制剂适用为进展性，转移甲状腺髓样癌(MTC)患者的治疗。</td>
              </tr>

              <tr > <td x:num="25" >25</td>
              <td>Lorbrena</td>
              <td>Lorlatinib</td>
              <td>肺癌</td>
              <td>辉瑞</td>
              <td >本产品用于治疗既往接受过ALK抑制剂（克唑替尼+至少其他一种ALK抑制剂，或阿来替尼，或赛瑞替尼作为第一个ALK抑制剂）治疗但病情进展的ALK阳性转移性非小细胞肺癌</td>
              </tr>

              <tr > <td x:num="26" >26</td>
              <td >PORTRAZZA</td>
              <td >Necitumumab</td>
              <td >肺癌</td>
              <td >礼来</td>
              <td >与吉西他滨和顺铂联合用于转移性鳞状非小细胞肺癌患者的一线治疗。<br />
              使用限制：PORTRAZZA不适用于治疗非鳞状非小细胞肺癌</td>
              </tr>

              <tr > <td x:num="27" >27</td>
              <td>Tabrecta</td>
              <td>Capmatinib</td>
              <td>肺癌</td>
              <td>诺华肿瘤</td>
              <td >本产品用于治疗MET14号外显子跳跃突变非小细胞肺癌 </td>
              </tr>

              <tr > <td x:num="28" >28</td>
              <td >Tepmetko</td>
              <td >Tepotinib</td>
              <td >肺癌</td>
              <td >默克</td>
              <td >本产品用于治疗携带间质上皮转化因子基因外显14（METex14）跳跃突变的晚期非小细胞肺癌（NSCLC）成人患者</td>
              </tr>

              <tr > <td x:num="29" >29</td>
              <td >Zepzelca</td>
              <td >lurbinectedin</td>
              <td >肺癌</td>
              <td >绿叶制药</td>
              <td >本产品用于治疗转移小细胞肺癌铂类药物进展后的二线治疗</td>
              </tr>

              <tr > <td x:num="30" >30</td>
              <td >泰瑞沙</td>
              <td >甲磺酸奥希替尼片</td>
              <td >肺癌</td>
              <td >阿斯利康</td>
              <td >本产品用于治疗手术后IB-IIIA期EGFR突变的非小细胞肺癌的辅助治疗</td>
              </tr>

              <tr > <td x:num="31" >31</td>
              <td>英飞凡</td>
              <td>Durvalumab</td>
              <td>肺癌</td>
              <td>阿斯利康</td>
              <td >本产品联合化疗用于未经系统治疗的广泛期小细胞肺癌患者的治疗</td>
              </tr>

              <tr > <td x:num="32" >32</td>
              <td>Mekinist</td>
              <td>曲美替尼</td>
              <td>肺癌、甲状腺癌</td>
              <td>诺华肿瘤</td>
              <td >本产品与dabrafenib结合使用，用于：<br />
              1、brafv600e突变对转移性非小细胞肺癌（NSCLC）患者的治疗<br />
              2、BRAFV600E突变的局部晚期或转移性间变性甲状腺癌（ATC）患者</td>
              </tr>

              <tr > <td x:num="33" >33</td>
              <td>Tafinlar</td>
              <td>甲磺酸达拉非尼</td>
              <td>肺癌、甲状腺癌</td>
              <td>诺华肿瘤</td>
              <td >本产品与曲美替尼合用用于：<br />
              1、brafv600e突变对转移性非小细胞肺癌（NSCLC）患者的治疗<br />
              2、BRAFV600E突变的局部晚期或转移性间变性甲状腺癌（ATC）患者</td>
              </tr>

              <tr > <td x:num="34" >34</td>
              <td >Retevmo</td>
              <td >selpercatinib</td>
              <td >肺癌、甲状腺髓样癌、甲状腺癌</td>
              <td>礼来</td>
              <td >本产品用于治疗：<br />
              1、转染重排基因(RET)融合阳性的转移性非小细胞肺癌(NSCLC)的成年患者;<br />
              2、需要系统性治疗的携带RET突变的晚期或转移性甲状腺髓样癌成人和12岁及以上的儿童患者<br />
              3、需要系统性治疗和放射性碘治疗(如适用)难治的RET融合阳性的晚期或转移性甲状腺癌成人和12岁及以上的儿童患者</td>
              </tr>

              <tr > <td x:num="35" >35</td>
              <td>KEYTRUDA</td>
              <td>帕博利珠单抗</td>
              <td>肝癌、鼻咽癌</td>
              <td>默沙东</td>
              <td >1、本产品用于二线治疗索拉非尼经治的肝细胞癌<br />
              2、PD-1表达&gt;1%的晚期不可切除鼻咽癌患者单药治疗</td>
              </tr>

              <tr > <td x:num="36" >36</td>
              <td >Inrebic</td>
              <td >Fedratinib</td>
              <td >骨髓纤维化</td>
              <td >施贵宝</td>
              <td >用于治疗中危-2和高危原发和继发性骨髓纤维化</td>
              </tr>

              <tr > <td x:num="37" >37</td>
              <td>Cotellic</td>
              <td>Cobimetinib/考比替尼</td>
              <td>黑色素瘤</td>
              <td>罗氏制药</td>
              <td >本产品用于治疗BRAF V600E或V600K突变阳性、不可切除性或转移性黑色素瘤患者的治疗</td>
              </tr>

              <tr > <td x:num="38" >38</td>
              <td>Imlygic</td>
              <td>talimogene laherparepvec</td>
              <td >黑色素瘤</td>
              <td>安进</td>
              <td >IMLYGIC是一种遗传上修饰的溶瘤病毒治疗适用为有黑色素瘤初始手术后复发患者中不可切除的皮肤，皮下，和淋巴结病变的局部治疗。使用限制：IMLYGIC未曾显示改善总生存或对内脏转移有影响。</td>
              </tr>

              <tr > <td x:num="39" >39</td>
              <td>Mektovi</td>
              <td>Binimetinib</td>
              <td>黑色素瘤</td>
              <td >皮尔法伯</td>
              <td >与Encorafenib联合用于治疗BRAF V600E或V600K突变的不可切除或转移性黑色素瘤患者。</td>
              </tr>

              <tr > <td x:num="40" >40</td>
              <td>Yervoy</td>
              <td>伊匹木单抗注射液</td>
              <td>黑色素瘤</td>
              <td >施贵宝</td>
              <td >伊匹木单抗是一种靶向细胞毒性T淋巴细胞相关抗原4（CTLA-4）的人源化单克隆抗体。伊匹木单抗是全球首个也是唯一一个获批的CTLA-4免疫检查点抑制剂。用于治疗晚期黑色素瘤。</td>
              </tr>

              <tr > <td x:num="41" >41</td>
              <td >欧狄沃</td>
              <td>纳武利尤单抗</td>
              <td >黑色素瘤、肾癌、淋巴瘤、尿路上皮癌、肝癌、结直肠癌、食管癌</td>
              <td >施贵宝</td>
              <td >本产品适用于：<br />
              1、单药或与伊匹木单抗联合用于治疗晚期黑色素瘤；<br />
              2、单药用于治疗既往接受过治疗的晚期肾细胞癌；<br />
              3、单药用于治疗自体造血干细胞移植（ASCT）和brentuximab vedotin治疗后的复发性或难治性经典型霍奇金淋巴瘤<br />
              4、单药用于治疗既往接受过含铂治疗的局部晚期不可切除的或转移性尿路上皮癌<br />
              5、单药或与伊匹木单抗联合用于肝细胞癌的二线治疗<br />
              6、单药或与伊匹木单抗联合用于治疗经氟尿嘧啶、奥沙利铂和伊立替康治疗后疾病进展的微卫星高度稳定性（MSI-H）或错配修复缺陷（dMMR）转移性结直肠癌。<br />
              7、单药用于治疗既往接受过含氟嘧啶和铂类药物化疗的不可切除晚期、复发性或转移性食管鳞状细胞癌</td>
              </tr>

              <tr > <td x:num="42" >42</td>
              <td >普吉华</td>
              <td >普拉替尼</td>
              <td >甲状腺髓样癌、甲状腺癌</td>
              <td >基石药业</td>
              <td >本产品用于治疗：<br />
              1、RET突变需要系统治疗的12岁及以上晚期或转移性甲状腺髓样癌成人和儿童患者；<br />
              2、RET融合阳性需要系统治疗且放射性碘难治的12岁及以上晚期或转移性甲状腺癌成人和儿童患者；</td>
              </tr>

              <tr > <td x:num="43" >43</td>
              <td >BRAFTOVI</td>
              <td >Encorafenib</td>
              <td >结直肠癌、黑色素瘤</td>
              <td >皮尔法伯</td>
              <td >本产品适用于：<br />
              1、与西妥昔单抗联用，用于治疗接受BRAF V600E突变的成年转移性结直肠癌（CRC）成年患者，这些患者已接受过全身性治疗。<br />
              2、与Binimetinib联合用于治疗BRAF V600E或V600K突变的不可切除或转移性黑色素瘤患者。 </td>
              </tr>

              <tr > <td x:num="44" >44</td>
              <td>Panretin</td>
              <td>Alitretinoin 阿利维A酸</td>
              <td>卡波西氏肉瘤</td>
              <td>维健医药</td>
              <td >Panretin®凝胶可用于与AIDS相关的卡波西氏肉瘤患者的皮肤病变的局部治疗。</td>
              </tr>

              <tr > <td x:num="45" >45</td>
              <td >Adcetris</td>
              <td >Brentuximab Vedotin for Injection</td>
              <td >淋巴瘤</td>
              <td >武田</td>
              <td >本产品用于治疗以下CD30阳性淋巴瘤成人患者：<br />
              1、与化疗联合治疗既往未经治疗的系统性间变性大细胞淋巴瘤（sALCL）或其他表达CD30的外周T细胞淋巴瘤 （PTCL），包括血管免疫母细胞性T细胞淋巴瘤（AITL）和非特指型PTCT（PTCL-NOS）;<br />
              2、与化疗联合治疗既往未经治疗的III期或IV期经典型霍奇金淋巴瘤;</td>
              </tr>

              <tr > <td x:num="46" >46</td>
              <td >Istodax</td>
              <td >romidepsin</td>
              <td >淋巴瘤</td>
              <td>Celgene Corporation</td>
              <td >ISTODAX是一种组蛋白去乙酰化酶(HDAC)抑制剂，适用于既往已接受至少1种系统治疗的皮肤或外周T细胞淋巴瘤(CTCL)患者的治疗</td>
              </tr>

              <tr > <td x:num="47" >47</td>
              <td>Polivy</td>
              <td>Polatuzumab Vedotin</td>
              <td>淋巴瘤</td>
              <td>上海罗氏制药有限公司</td>
              <td >本产品用于治疗复发/难治性弥漫性大B细胞淋巴瘤（DLBCL）成人患者</td>
              </tr>

              <tr > <td x:num="48" >48</td>
              <td >YUTIQ</td>
              <td >FLUOCINOLONE ACETONIDE </td>
              <td >葡萄膜炎</td>
              <td >欧康维视</td>
              <td >累及眼后段的慢性非感染性葡萄膜炎</td>
              </tr>

              <tr > <td x:num="49" >49</td>
              <td >UKONIQ</td>
              <td >umbralisib </td>
              <td >淋巴瘤</td>
              <td >TG Therapeutics, Inc.</td>
              <td >UKONIQ是一种激酶抑制剂，用于治疗成人患者：<br />
              复发或难治性边缘区淋巴瘤（MZL），至少接受过一次以抗CD20为基础的方案<br />
              复发或难治性滤泡性淋巴瘤（FL），至少接受过三次系统治疗。</td>
              </tr>

              <tr > <td x:num="50" >50</td>
              <td>Zynlonta</td>
              <td>loncastuximab tesirine-lpyl</td>
              <td>淋巴瘤</td>
              <td>Adc Therapeutics America, Inc.</td>
              <td >本产品用于治疗接受过两线或两线以上系统性治疗的成人复发或难治性的大B细胞淋巴瘤患者，包括弥漫性大B细胞淋巴瘤（DLBCL）非特指型、由低级别淋巴瘤转化的DLBCL以及高级别B细胞淋巴瘤患者</td>
              </tr>

              <tr > <td x:num="51" >51</td>
              <td >亿珂</td>
              <td >伊布替尼胶囊</td>
              <td >淋巴瘤</td>
              <td >西安杨森</td>
              <td >边缘区淋巴瘤 （MZL）</td>
              </tr>

              <tr > <td x:num="52" >52</td>
              <td >令癌莎/Lynparza</td>
              <td >Olaparib/奥拉帕尼</td>
              <td >卵巢癌、前列腺癌、乳腺癌、胰腺癌</td>
              <td >阿斯利康</td>
              <td >1、卵巢癌：用于对一线铂类化疗完全或部分有效的有害或可疑有害生殖系或体细胞BRCA突变晚期上皮性卵巢癌、输卵管癌或原发性腹膜癌的成年患者的维持治疗。<br />
              与贝伐单抗联合用于晚期上皮性卵巢癌成人患者的维持治疗，输卵管癌或原发性腹膜癌，对一线铂类化疗完全或部分应答，且其癌症与同源重组缺陷（HRD）阳性状态相关,定义如下：<br />
              •有害或疑似有害BRCA突变和/或基因组不稳定性。<br />
              •对复发性上皮性卵巢癌、输卵管癌或原发性腹膜癌的成人患者进行维持治疗，这些患者对铂类化疗完全或部分有效。<br />
              •用于治疗患有有害或疑似有害生殖系BRCA突变（gBRCAm）晚期卵巢癌的成年患者，这些患者曾接受过三种或三种以上的化疗。根据FDA批准的Lynparza伴随诊断选择患者进行治疗。<br />
              <br />
              2、前列腺癌：用于治疗患有有害或疑似有害生殖系或体细胞同源重组修复（HRR）基因突变的转移性去势抵抗前列腺癌（mCRPC）的成年患者，这些患者在先前使用恩扎鲁胺或阿比特龙治疗后有进展。<br />
              <br />
              3、乳腺癌:用于治疗有害或可疑有害gBRCAm、HER2阴性转移性乳腺癌的成年患者，这些患者在新辅助、辅助或转移环境下接受了化疗。激素受体（HR）阳性乳腺癌患者应事先接受内分泌治疗，或认为不适合进行内分泌治疗。<br />
              <br />
              4、胰腺癌:对患有有害或可疑有害gBRCAm转移性胰腺癌的成人患者进行维持治疗，这些患者在一线铂类化疗方案治疗至少16周后病情没有进展。</td>
              </tr>

              <tr > <td x:num="53" >53</td>
              <td >Bavencio</td>
              <td >Avelumab</td>
              <td >默克尔细胞癌、尿路上皮癌、肾癌</td>
              <td >默克</td>
              <td >本产品适用：<br />
              1、为成年和儿童12岁和以上有转移转移性默克尔细胞癌(MCC)患者。<br />
              2、一线含铂化疗后疾病未进展的局部晚期或转移性尿路上皮癌患者的维持治疗。<br />
              3、治疗下列局部晚期或转移性尿路上皮癌患者：在含铂化疗期间或之后发生疾病进展；在使用含铂化疗进行新辅助治疗或辅助治疗之后12个月内发生疾病进展；<br />
              4、与阿昔替尼联合，适用于晚期肾细胞癌患者的一线治疗。</td>
              </tr>

              <tr > <td x:num="54" >54</td>
              <td>Balversa</td>
              <td>Erdafitinib Tablet</td>
              <td>尿路上皮癌</td>
              <td>西安杨森制药有限公司</td>
              <td >本品适用于治疗满足以下情况的局部晚期或转移性尿路上皮癌（mUC）成人患者：存在FGFR3或FGFR2易感型基因改变，并且 既往接受过至少一线含铂药物化疗且化疗期间或之后出现疾病进展，包括在接受含铂药物的新辅助化疗或辅助化疗后12个月内出现疾病进展</td>
              </tr>

              <tr > <td x:num="55" >55</td>
              <td >Padcev</td>
              <td >Enfortumab vedotin</td>
              <td >尿路上皮癌</td>
              <td >安斯泰来</td>
              <td >本产品用于治疗既往已接受一种PD-1/L1抑制剂治疗、并且在新辅助/辅助治疗或在局部晚期或转移性疾病治疗中已接受了一种含铂化疗方案的局部晚期或转移性尿路上皮癌患者。</td>
              </tr>

              <tr > <td x:num="56" >56</td>
              <td >Xtandi</td>
              <td >Enzalutamide</td>
              <td >前列腺癌</td>
              <td >安斯泰来</td>
              <td >本产品用于治疗转移性激素敏感性前列腺癌（M1HSPC）</td>
              </tr>

              <tr > <td x:num="57" >57</td>
              <td >Herceptin Hylecta</td>
              <td >Tratuzumab/hyaluronidase-oysk</td>
              <td >乳腺癌</td>
              <td >罗氏制药</td>
              <td >本产品用于治疗早期和转移性HER2阳性乳腺癌</td>
              </tr>

              <tr > <td x:num="58" >58</td>
              <td>Kisqali</td>
              <td>Ribociclib</td>
              <td>乳腺癌</td>
              <td>诺华肿瘤</td>
              <td >本产品用于治疗HR+HER2-绝经前/绝经后晚期乳腺癌 </td>
              </tr>

              <tr > <td x:num="59" >59</td>
              <td >Margenza</td>
              <td >Margetuximab</td>
              <td >乳腺癌</td>
              <td >再鼎医药</td>
              <td >本产品联合化疗治疗接受过两种或两种以上抗HER2方案（其中至少一种方案是治疗转移性疾病）的成人转移性HER2阳性乳腺癌患者</td>
              </tr>

              <tr > <td x:num="60" >60</td>
              <td >Phesgo</td>
              <td >Pertuzumab/trastuzumab/Hyaluronidase-zzxf</td>
              <td >乳腺癌</td>
              <td >罗氏制药</td>
              <td >本产品用于治疗早期和转移性HER2阳性乳腺癌患者</td>
              </tr>

              <tr > <td x:num="61" >61</td>
              <td>Piqray</td>
              <td>Alpelisib</td>
              <td>乳腺癌</td>
              <td>诺华肿瘤</td>
              <td >本产品用于治疗HR+HER2-绝经后PIK3CA突变晚期乳腺癌 </td>
              </tr>

              <tr > <td x:num="62" >62</td>
              <td>Talzenna</td>
              <td>Talazoparib</td>
              <td>乳腺癌</td>
              <td>辉瑞</td>
              <td >本产品用于治疗BRCA突变、HER2阴性局部晚期或转移性乳腺癌患者</td>
              </tr>

              <tr > <td x:num="63" >63</td>
              <td>泰圣奇</td>
              <td>阿替利珠单抗注射液</td>
              <td >乳腺癌、肺癌、尿路上皮癌、黑色素瘤</td>
              <td>上海罗氏制药有限公司</td>
              <td >本产品适用：<br />
              1、与白蛋白紫杉醇联用，适用于治疗无法切除的局部晚期或转移性三阴性乳腺癌的成年患者，患者需经批准的检测确定肿瘤具有 D-L1 高表达 (PD-L1 染色肿瘤浸润免疫细胞（IC）≥1 %)<br />
              2、单药用于铂类药物治疗后疾病进展以及接受 EGFR 或 ALK 靶向药物治疗后疾病进展的转移性非小细胞肺癌患者<br />
              3、与贝伐珠单抗、紫杉醇和卡铂联用，用于表皮生长因子受体（EGFR）基因突变阴性和间变性淋巴瘤激酶（ALK）阴性的转移性非鳞状非小细胞肺癌的一线治疗<br />
              4、联合卡铂和紫杉醇用于转移性非鳞状非小细胞肺癌的一线治疗<br />
              5、用于治疗局部晚期或转移性尿路上皮癌的成人患者：<br />
              没有资格接受含顺铂的化疗，并且其肿瘤表达PD-L1（PD-L1染色的肿瘤浸润免疫细胞[IC]）≥ 肿瘤面积的5%），由FDA批准的试验确定，或无论PD-L1状态如何，患者均无资格接受任何含铂化疗的。<br />
              6、联合cobimetinib和vemurafenib治疗brafv600突变阳性的不可切除或转移性黑色素瘤。</td>
              </tr>

              <tr > <td x:num="64" >64</td>
              <td >Trodelvy</td>
              <td >Sacituzumab Govitecan for Injection</td>
              <td >乳腺癌、尿路上皮癌</td>
              <td >云顶新耀</td>
              <td >本产品用于治疗：<br />
              1：接受过至少2种系统性既往治疗的不可切除的局部晚期或转移性三阴性乳腺癌成人患者 ； <br />
              2：治疗既往接受过含铂化疗，以及PD-1 或 PD-L1抑制剂治疗的局部晚期或转移性尿路上皮癌（mUC）患者 </td>
              </tr>

              <tr > <td x:num="65" >65</td>
              <td>Enhertu</td>
              <td>Fam-trastuzumab deruxtecan-nxki</td>
              <td>乳腺癌、胃癌</td>
              <td>第一三共</td>
              <td >本产品用于治疗：<br />
              1、HER2阳性，之前曾经接受过曲妥珠单抗治疗的无法切除的和/或转移性的乳腺癌<br />
              2、用于治疗先前接受过曲妥珠单抗治疗的局部晚期或转移性HER2阳性胃癌或胃食管交界处（GEJ）腺癌的成年患者</td>
              </tr>

              <tr > <td x:num="66" >66</td>
              <td >维全特</td>
              <td >培唑帕尼</td>
              <td >软组织肉瘤</td>
              <td >诺华肿瘤</td>
              <td >本产品用于治疗特定子类型的晚期软组织肉瘤</td>
              </tr>

              <tr > <td x:num="67" >67</td>
              <td>海乐卫</td>
              <td>甲磺酸艾立布林注射液</td>
              <td >软组织肉瘤、脂肪肉瘤</td>
              <td>卫材（中国）药业有限公司</td>
              <td >本产品用于治疗软组织肉瘤、脂肪肉瘤</td>
              </tr>

              <tr > <td x:num="68" >68</td>
              <td >Qarziba</td>
              <td >达妥昔单抗β</td>
              <td >神经母细胞瘤</td>
              <td >百济神州</td>
              <td >本产品用于治疗≥12月龄的高危神经母细胞瘤患者，这些患者既往接受过诱导化疗且至少获得部分缓解，并且随后进行过清髓性治疗和干细胞移植治疗；也适用于治疗伴或不伴有残留病灶的复发性或难治性神经母细胞瘤。在治疗复发性神经母细胞瘤之前，应采取适当措施使活动性进展性疾病保持稳定</td>
              </tr>

              <tr > <td x:num="69" >69</td>
              <td >Koselugo</td>
              <td >Selumetinib</td>
              <td >神经纤维瘤</td>
              <td >阿斯利康</td>
              <td >2岁及以上的患有1型神经纤维瘤病（NF1）且有症状的、无法手术的丛状神经纤维瘤（PN）的儿童患者</td>
              </tr>

              <tr > <td x:num="70" >70</td>
              <td >Fotivda</td>
              <td >tivozanib</td>
              <td >肾癌</td>
              <td>Aveo Pharmaceuticals, Inc.</td>
              <td >FOTIVDA是一种激酶抑制剂，用于治疗复发或难治性晚期肾细胞癌（RCC）的成人患者</td>
              </tr>

              <tr > <td x:num="71" >71</td>
              <td>LENVIMA</td>
              <td>甲磺酸仑伐替尼胶囊</td>
              <td >肾癌、子宫内膜癌</td>
              <td >卫材（中国）药业有限公司</td>
              <td >本产品适用于：<br />
              1、与依维莫司联合用药，治疗既往曾接受过抗血管生成治疗的肾细胞癌患者<br />
              2、与帕博利珠单抗联合，治疗既往接受全身治疗后出现疾病进展的，不适合根治性手术或放疗的，非微卫星高度不稳定（MSI-H）或错配修复缺陷（dMMR）的晚期子宫内膜癌患者</td>
              </tr>

              <tr > <td x:num="72" >72</td>
              <td>Rozlytrek</td>
              <td>Entrectinib</td>
              <td>实体瘤、肺癌</td>
              <td>上海罗氏制药有限公司</td>
              <td >本产品适用：<br />
              1、用于目前无有效治疗方法的12岁及以上神经营养性酪氨酸受体激酶（NTRK）基因融合阳性晚期实体瘤儿科及成人患者的治疗<br />
              2、用于ROS1阳性转移性非小细胞肺癌（NSCLC）成人患者的治疗</td>
              </tr>

              <tr > <td x:num="73" >73</td>
              <td >LONSURF</td>
              <td >曲氟尿苷替匹嘧啶</td>
              <td >胃癌</td>
              <td >大鹏</td>
              <td >本产品用于治疗既往至少接受过2线化疗治疗的转移性胃或食管胃连接部腺癌成人患者，其中化疗包括氟嘧啶、铂类药物、紫杉烷或伊立替康以及适当时，HER2/neu靶向治疗。</td>
              </tr>

              <tr > <td x:num="74" >74</td>
              <td >Onivyde</td>
              <td >盐酸伊立替康脂质体注射液</td>
              <td >胰腺癌</td>
              <td >施维雅</td>
              <td >本产品与5-氟尿嘧啶（5-FU）和亚叶酸（LV）一同使用治疗既往以吉西他滨为基础的化疗方案治疗失败，疾病进展的转移性胰腺导管腺癌患者</td>
              </tr>

              <tr > <td >75</td>
              <td >Jemperli</td>
              <td >dostarlimab</td>
              <td >子宫内膜癌</td>
              <td >葛兰素史克</td>
              <td >本产品用于治疗复发或晚期子宫内膜癌</td>
              </tr>
          </table>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ClaimPoint',

  components: {},

  filters: {},

  mixins: [],

  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() { },

  mounted() { },

  destroyed() { },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
// .header_content {
//   text-align: center;
// }
// .nav-part {
//   padding: 0 px2rem(28, 375);
//   font-size: px2rem(14, 375);
//   line-height: 2;
//   a {
//     text-decoration: underline;
//   }
// }
// .part-title {
//   font-size: px2rem(14, 375);
//   font-weight: bold;
//   margin-bottom: px2rem(5, 375);
// }
// .clause-block {
//   line-height: 1.5;
// }
// .gules {
//   color: #ce3327;
// }

// img {
//   width: 100%;
// }

.app-main {
  padding: 20px 30px;
  overflow: hidden;
  font-size: 14px;
     .drugtitle{
    border-left: 4px solid #EA342B;
    padding-left: 4px;
     }
     .production-table {
        // 产品信息表格
        // background-color: skyblue;
        // margin: px2rem(23) px2rem(35) ;
        // max-width: 600px;
        margin: px2rem(23) auto px2rem(80);
        border: 1px solid #EA342B;
        border-collapse: collapse;
        word-break: break-all; 

        th,
        td {
          border: 1px solid #EA342B;
          color: #fff;
          padding: px2rem(20);
          font-size: px2rem(23);
          // line-height: px2rem(40);
          text-align: center;
        }
        tr {
          th {
            background-color: #EA342B;
            font-size: px2rem(29);
            font-weight: bold;
            text-align: center;
            &:first-child {
              width: 9%;
            }
            &:nth-child(2) {
              width: 20%;
            }
            &:nth-child(3) {
              width: 20%;
            }
            &:nth-child(4) {
              width: 17%;
            }
            //  &:nth-child(5) {
            //   width: 20%;
            // }
             &:nth-child(6) {
              width: 50%;
            }
          }
          td {
            color: #EA342B;
            text-align: center;
            &:first-child {
              // background-color: #EA342B;
              text-align: center;
            }
          }
        }
      }
}


</style>
